import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';
import { Navigate, Route } from 'react-router-dom';
import { InvestmentJoinAndAllocation } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { InvestmentManage } from '@dealstack/frontend/investor/pages/Investment/InvestmentManage/InvestmentManage';
import { InvestmentLeave } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeave';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { useInvestmentController } from '@dealstack/frontend/investor/pages/Investment/useInvestmentController';
import { INVESTMENT_ROUTES } from '@dealstack/frontend/investor/pages/Investment/Investment.routes';

export const Investment = () => {
	useInvestmentController();

	return (
		<div style={{ flexGrow: 1, maxHeight: 'calc(100vh - 3.5rem)', overflow: 'hidden' }}>
			<SentryRoutes>
				<Route
					path={`${INVESTMENT_ROUTES.JOIN_ALLOCATION}/*`}
					element={<InvestmentJoinAndAllocation />}
				/>
				<Route path={`${INVESTMENT_ROUTES.MANAGE}/*`} element={<InvestmentManage />} />
				<Route path={`${INVESTMENT_ROUTES.LEAVE}/*`} element={<InvestmentLeave />} />
				<Route path="*" element={<Navigate to={ROUTES.DASHBOARD} />} />
			</SentryRoutes>
		</div>
	);
};
